<!-- ================= Bus list ================= -->
<div class="st-page" *ngIf="view === 'busList'">
  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'transport' | translate }}</h1>
      <p class="st-subtitle">{{ buses.length }} {{ 'vehiclesInOperationToday' | translate }}</p>
    </div>
    <button type="button" class="st-btn st-btn-secondary" *ngIf="isSuperAdmin" (click)="toggleSelfAssigned()">
      <i class="ri-user-line"></i> {{ 'selfAssignedOnly' | translate }}
      <span class="st-chip" [ngClass]="selfAssignedOnly ? 'st-chip-blue' : 'st-chip-grey'">{{ selfAssignedOnly ? 'ON' : 'OFF' }}</span>
    </button>
  </div>

  <div class="sb-search-box" *ngIf="buses.length || searchTerm">
    <i class="ri-search-line"></i>
    <input type="text" [(ngModel)]="searchTerm" placeholder="{{ 'search' | translate }}" />
  </div>

  <div class="st-tv-list" *ngIf="loadingBuses">
    <div class="st-card sf-skeleton-line" style="height: 120px;" *ngFor="let s of skeletonBuses"></div>
  </div>

  <ng-container *ngIf="!loadingBuses">
    <div class="st-tv-list">
      <div class="st-card st-tv-item" *ngFor="let bus of filteredBuses">
        <div class="st-tv-head" (click)="openBus(bus)">
          <span class="tp-number-plate">{{ bus.busNumber }}</span>
        </div>
        <div class="st-tv-body" (click)="openBus(bus)">
          <div class="st-tv-info">{{ bus.busRouteName }}</div>
          <div class="st-tv-info" *ngIf="bus.driverName">
            <i class="ri-user-line"></i> {{ 'driver' | translate }}: {{ bus.driverName }}<ng-container *ngIf="bus.driverMobileNumber"> : {{ bus.driverMobileNumber }}</ng-container>
          </div>
          <div class="st-tv-info" *ngIf="bus.busInchargeName">
            <i class="ri-shield-user-line"></i> {{ 'busIncharge' | translate }}: {{ bus.busInchargeName }}<ng-container *ngIf="bus.busInchargeMobileNumber"> : {{ bus.busInchargeMobileNumber }}</ng-container>
          </div>
        </div>
        <div class="tp-tv-actions">
          <button type="button" class="st-btn st-btn-secondary tp-call-btn" *ngIf="bus.driverMobileNumber" (click)="callNumber(bus.driverMobileNumber); $event.stopPropagation()">
            <i class="ri-phone-line"></i> {{ 'call' | translate }} {{ 'driver' | translate }}
          </button>
          <button type="button" class="st-btn st-btn-secondary tp-call-btn" *ngIf="bus.busInchargeMobileNumber" (click)="callNumber(bus.busInchargeMobileNumber); $event.stopPropagation()">
            <i class="ri-phone-line"></i> {{ 'call' | translate }} {{ 'busIncharge' | translate }}
          </button>
          <button type="button" class="st-btn st-btn-secondary tp-stops-btn" (click)="openStops(bus)">
            <i class="ri-map-pin-line"></i> {{ 'viewStops' | translate }}
          </button>
        </div>
      </div>
    </div>

    <p class="sf-empty" *ngIf="!filteredBuses.length">{{ 'noBusesFound' | translate }}</p>
  </ng-container>
</div>

<!-- Bus stops bottom sheet -->
<div class="sb-drawer-overlay" *ngIf="showStopsSheet" (click)="closeStopsSheet()">
  <div class="sb-drawer" (click)="$event.stopPropagation()">
    <div class="sb-drawer-head">
      <h3 class="sb-drawer-title">{{ 'busStops' | translate }} &mdash; {{ stopsBusName }}</h3>
      <button class="sb-drawer-close" (click)="closeStopsSheet()"><i class="ri-close-line"></i></button>
    </div>
    <div class="sb-drawer-body">
      <div class="sf-skeleton-chart" *ngIf="loadingStops"></div>
      <ng-container *ngIf="!loadingStops">
        <div class="tp-stop-timeline" *ngIf="stopsForBus.length">
          <div class="tp-stop-row" *ngFor="let stop of stopsForBus; let i = index; let last = last">
            <div class="tp-stop-dot-wrap">
              <span class="tp-stop-dot"></span>
              <span class="tp-stop-line" *ngIf="!last"></span>
            </div>
            <span class="tp-stop-name">{{ stop.BusStopName }}</span>
          </div>
        </div>
        <p class="sf-empty" *ngIf="!stopsForBus.length">{{ 'noStopsFound' | translate }}</p>
      </ng-container>
    </div>
  </div>
</div>

<!-- ================= Student roster ================= -->
<div class="st-page" *ngIf="view === 'studentRoster'">
  <div class="st-page-head">
    <div class="sf-monthly-title-row">
      <button type="button" class="sf-back-btn" (click)="backToBusList()"><i class="ri-arrow-left-line"></i></button>
      <div>
        <h1 class="st-title">{{ 'transport' | translate }}</h1>
        <span class="tp-number-plate">{{ selectedBus?.busNumber }}</span>
      </div>
    </div>
    <button type="button" class="sf-search-toggle" *ngIf="students.length" (click)="toggleStudentSearch()">
      <i class="ri-search-line"></i>
    </button>
  </div>

  <div class="sb-search-box" *ngIf="studentSearchOpen">
    <i class="ri-search-line"></i>
    <input type="text" [(ngModel)]="studentSearchTerm" placeholder="{{ 'searchStudent' | translate }}" autofocus />
  </div>

  <div class="st-tv-list" *ngIf="loadingStudents">
    <div class="st-card sf-skeleton-line" style="height: 70px;" *ngFor="let s of skeletonStudents"></div>
  </div>

  <ng-container *ngIf="!loadingStudents">
    <div class="st-tv-list">
      <div class="st-card tp-student-row" *ngFor="let student of filteredStudents">
        <div class="tp-student-avatar">
          <img *ngIf="student.studentImageUrl" [src]="student.studentImageUrl" alt="{{ student.studentFullName }}" />
          <i class="ri-user-3-line" *ngIf="!student.studentImageUrl"></i>
        </div>
        <div class="st-list-text">
          <div class="st-list-title">{{ student.studentFullName }}</div>
          <div class="st-list-sub">{{ student.classNumber }} {{ student.classDivision }} &middot; {{ student.parentName }}</div>
        </div>
        <button type="button" class="st-btn st-btn-secondary tp-call-btn" *ngIf="student.mobileNumber" (click)="callNumber(student.mobileNumber)">
          <i class="ri-phone-line"></i> {{ student.mobileNumber }}
        </button>
      </div>
    </div>

    <p class="sf-empty" *ngIf="!filteredStudents.length">{{ 'noStudentsFoundForBus' | translate }}</p>
  </ng-container>

  <button type="button" class="tp-map-fab" *ngIf="vehicleTrackingEnabled" (click)="openLiveMap()">
    <i class="ri-map-pin-line"></i>
  </button>
</div>

<!-- ================= Live map ================= -->
<div class="st-page tp-live-map-page" *ngIf="view === 'liveMap'">
  <div class="st-page-head">
    <div class="sf-monthly-title-row">
      <button type="button" class="sf-back-btn" (click)="backToStudentRoster()"><i class="ri-arrow-left-line"></i></button>
      <div>
        <h1 class="st-title">{{ 'trackVehicle' | translate }}</h1>
        <span class="tp-number-plate">{{ selectedBus?.busNumber }}</span>
      </div>
    </div>
  </div>

  <div class="tp-map-card">
    <div class="tp-map-loader" *ngIf="fetchingLocation">
      <app-button-loader></app-button-loader>
    </div>
    <div id="sf-transport-map" class="tp-map-canvas" [hidden]="fetchingLocation"></div>

    <div class="tp-map-info-strip" *ngIf="!fetchingLocation">
      <div class="tp-map-info-item"><span class="tp-number-plate tp-number-plate-sm">{{ selectedBus?.busNumber }}</span></div>
      <div class="tp-map-info-divider"></div>
      <div class="tp-map-info-item"><i class="ri-speed-line"></i> {{ vehicleSpeedKmh }} {{ 'kmPerHour' | translate }}</div>
    </div>
  </div>
</div>
